module.exports = __webpack_public_path__ + "assets/img/17_1793.b575c712.jpg";